import React, { useCallback, useState } from 'react';
import { Card } from '@mui/material';
import { CreateNewAlbumForm } from '../Forms/CreateNewAlbumForm.tsx';
import { UploadImageForm } from '../Forms/UploadImageForm.tsx';
import { ManageAlbums } from '../Forms/ManageAlbums.tsx';
import './AdminDashboards.scss';

export function MediaDashboard(props) {
    const { alert } = props;
    const [refresher, setRefresher] = useState(false);

    const refreshHandler = useCallback(() => {
        setRefresher((previous) => !previous);
    }, []);

    return (
        <>
            <div id="media-dashboard">
                <h1>Media Dashboard</h1>
                <Card id="media-card" className="MuiCard-root form-card">
                    <CreateNewAlbumForm alert={alert} refreshHandler={refreshHandler} />
                    <UploadImageForm 
                        alert={alert}
                        refresh={refresher} 
                        refreshHandler={refreshHandler} 
                    />
                </Card>
                <Card id="media-management-card" className="MuiCard-root form-card">
                    <ManageAlbums
                        alert={alert}
                        refresh={refresher} 
                        refreshHandler={refreshHandler} 
                    />
                </Card>
            </div>
        </>
        
    );
}
